'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ',
    ';\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: .125s box-shadow ease-out;\n  box-shadow: 0 2px 12px ',
    ';\n  border-radius: ',
    ';\n  border-width: 0;\n  border-style: solid;\n\n  ',
    ';\n\n  &:hover, &:focus {\n    outline: 0;\n    box-shadow: 0 2px 12px 2px ',
    ';\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 4px 16px 2px ',
    ';\n  }\n\n  ',
    ';\n'
  ],
  [
    '\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ',
    ';\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: .125s box-shadow ease-out;\n  box-shadow: 0 2px 12px ',
    ';\n  border-radius: ',
    ';\n  border-width: 0;\n  border-style: solid;\n\n  ',
    ';\n\n  &:hover, &:focus {\n    outline: 0;\n    box-shadow: 0 2px 12px 2px ',
    ';\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 4px 16px 2px ',
    ';\n  }\n\n  ',
    ';\n'
  ]
)

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Button = _Box2.default.withComponent('a').extend(
  _templateObject,
  function(props) {
    return props.theme.bold
  },
  function(props) {
    return props.theme.shadowColor
  },
  function(props) {
    return props.theme.pill
  },
  function(props) {
    return props.inverted
      ? {
          backgroundColor: props.theme.colors[props.color],
          color: props.theme.colors[props.bg]
        }
      : null
  },
  function(props) {
    return !props.inverted && props.bg === 'primary'
      ? 'rgba(228,45,66,.25)'
      : props.theme.shadowColor
  },
  function(props) {
    return !props.inverted && props.bg === 'primary'
      ? 'rgba(228,45,66,.375)'
      : props.theme.shadowColor
  },
  function(props) {
    return props.disabled ? 'opacity: 0.25' : null
  }
)

Button.displayName = 'Button'

Button.propTypes = {
  inverted: _propTypes2.default.bool
}

Button.defaultProps = {
  theme: _theme2.default,
  bg: 'primary',
  color: 'white',
  inverted: false,
  f: 3,
  m: 0,
  px: 3,
  py: 2
}

Button.button = Button.withComponent('button')
Button.input = Button.withComponent('input')

exports.default = Button



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Button.js
// module id = 61
// module chunks = 168707334958949